import {
  Loader,
  MultiSelect as MantineMultiSelect,
  MultiSelectProps,
} from "@mantine/core";
import get from "lodash/get";
import { useMemo } from "react";

interface Props extends MultiSelectProps {
  loading?: boolean;
}

const iconPropsMap = {
  s: { inputPaddingLeft: "20px", iconSize: 15, iconWidth: 20 },
  m: { inputPaddingLeft: "25px", iconSize: 15, iconWidth: 20 },
};

export const MultiSelect = ({ loading = false, ...props }: Props) => {
  const iconProps = useMemo(() => {
    return get(iconPropsMap, props.size ?? "s", iconPropsMap.s);
  }, [props.size]);

  return (
    <MantineMultiSelect
      styles={{
        input: {
          paddingLeft: loading ? iconProps.inputPaddingLeft : undefined,
        },
      }}
      icon={
        loading ? (
          <Loader size={iconProps.iconSize} style={{ marginLeft: "5px" }} />
        ) : undefined
      }
      iconWidth={iconProps.iconWidth}
      size={props.size}
      nothingFound="No results found"
      disabled={loading || props.disabled}
      {...props}
    />
  );
};
